<template>
<div class="grid"  @click="edit">
<div class="col-3 md:col-2" v-if="!hide_label">
<p class="click_edit_value_title">{{title}}:</p>
</div>


<template v-if="editing">

<div :class="inputareaclass">



<div class="grid mt-0"  v-click-away="cancel">
<div class="col">

<Dropdown 
v-model="inputdata" 
:options="translatedoptions" 
optionLabel="name" 
optionValue="id" 
class="w-full p-inputtext-sm"   
@change="submitChanges" 
:filter="showfilter" 
:emptyMessage="empty_message" >


<!-- value-->
<template #value="slotProps">
<div >{{$store.state.languages.lang_phrases[selectedValue]}}</div>
</template>
<!-- value-->
<!-- option-->
<template #option="slotProps">

<p class="p-link" :style="'color:#'+slotProps.option.color">{{$store.state.languages.lang_phrases[slotProps.option.name]}} <span class="color_selector_indicator ml-4" :style="'background-color:#'+slotProps.option.color"></span></p>

</template>
<!-- option-->

</Dropdown>

</div>
<div class="col-fixed " style="width:110px">
<Button type="button"  icon="pi pi-check" @click="submitChanges" class="p-button-primary p-button-outlined p-button-sm mr-2"  :loading="$store.state.ui.submitting" />
<Button type="button"  icon="pi pi-times" @click="cancel" class="p-button-danger p-button-outlined p-button-sm "  :loading="$store.state.ui.submitting" />
</div>
</div>
</div>
</template>

<template v-if="!editing">	
<div :class="inputareaclass">
<p class="click_edit_value my-0 pl-0">
<Tag 
class="ml-0 mt-1 custom-chip" 
:value="$store.state.languages.lang_phrases[returnvalue.name]" 
:style="'background-color:'+returnvalue.color"
/>

</p>

</div>
</template>

</div>	
</template>

<script>
export default {

  name: 'ClickEditSelectOptions',
  props:["title","value","valkey","options","hide_label","filter","read_only","color_selector","emptymessage"],
  data () {
    return {
    	editing:false,
    	inputdata:null,
    }
  },
  computed:{
    translatedoptions()
    {
      let options = this.options
      for(let option of options)
      {
        if(option.translations && option.translations.length)
        {
          let optiontranslation = option.translations.find((item)=>{return item.language_id ==this.$store.state.auth.user.preflang_id})
          if(optiontranslation)
          {
            option.name = optiontranslation.translation
          }
        }
      }
      return options
    },
    empty_message()
    {
      if(this.emptymessage)
      {
        return this.emptymessage
      }
      return "No available options"
    },
    selectedValue()
    {
      let item = this.options.find((item)=>{return item.id == this.inputdata})
      return item.name
    },
    readonly()
    {
      
      if(this.read_only)
      {
        return true
      }
      return false
    },
    colorselector()
    {
      if(this.color_selector)
      {
        return true
      }
      return false
    },
    showfilter()
    {
      if(this.filter)
      {
        return true
      }
      else
      {
        return false
      }
    },
    inputareaclass()
    {
      if(this.hide_label)
      {
        return "col-9 md:col-12 mt-0"
      }
      else
      {
        return "col-9 md:col-10 mt-0"
      }
    },
    returnvalue()
    {
      
      if(this.value)
      {
        let selected = this.options.find((item)=>{return item.id == this.value})
        if(!selected)
        {
          return null
        }
        else
        {
          
          return selected
        }
        
      }
      else
      {
        return {name:null,id:null,color:null}
      }      
    },    
    selectedColor()
    {
      if(this.value)
      {
        let selected = this.options.find((item)=>{return item.id == this.value})
        if(!selected)
        {
           return ""
        }
        return selected.color
      }
      else
      {
        return ""
      } 
    },
  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		  if(this.value===0)
          {this.inputdata=null}
  		 this.editing = false
  	}
  },
  methods:{
  	submitChanges()
  	{
      

      
  		if(this.inputdata !==this.value)
  		{
  			this.$emit("dataChanged",{value:this.inputdata,key:this.valkey})
  			//this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
  	edit()
  	{
      
      if(!this.readonly)
      {
        this.editing = true
        this.inputdata = this.value
        
        setTimeout(()=>{
          if(this.$refs.inputarea)
          {
            this.$refs.inputarea.$el.focus()
          }
          
        },10)
      }
  		
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
.color_selector_indicator{
  width: .8rem;
  height: .8rem;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
</style>